import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const SalesTextApi = {
  importSalesText: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/salestext/v1/create/file', { salesTextXmlZip: action.request })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getSalesText: (
    action: { page: number; limit: number; materialCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.materialCode) {
      queryParams.set(EUrlParams.Code, action.materialCode);
    }

    return AxiosClient.get(`/salestext/v1/read?${queryParams}`)
      .then((response) => {
        return handlePaginatedData(response, { ...action, searchCode: action.materialCode });
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.materialCode },
          EAction.Read,
          EApiType.SalesTextKey
        );
      });
  },
};
